module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"help":"What are Projects?","noSubmission":"(none)"}}')
  delete Component.options._Ctor
}
